import request from 'configuration/request';
import { httpBuildQuery } from 'helpers/utils';

export const agreementApi = {
  getAgreements: (params) => {
    return request({
      url: `/agreement/list/${httpBuildQuery(params)}`,
      method: 'GET',
    });
  },

  getOrganizations: () => {
    return request({
      url: '/organization/list/',
      method: 'GET',
    });
  },

  createAgreement: (data) => {
    return request({
      url: '/agreement/create/',
      method: 'POST',
      data,
    });
  },
};
